// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2qPyc","addWidgetButton":"Header_addWidgetButton__34NUK","dashboardTabs":"Header_dashboardTabs__17gDn","active":"Header_active__1XqxO"};